/**
 * Largest file the server will accept, in bytes (5 GiB).
 *
 * Must stay in step with nginx `client_max_body_size` and php-fpm
 * `upload_max_filesize` / `post_max_size`. Exceeding it server-side produces an
 * nginx 413 whose body is HTML, which every upload handler here tries to parse
 * as JSON — so the user gets a broken promise rather than a message. Reject the
 * file in the browser instead, before spending the transfer.
 */
export const MAX_UPLOAD_BYTES = 5 * 1024 * 1024 * 1024

export const formatBytes = (bytes, decimals) => {
  if (bytes == 0) {
    return '0 Bytes'
  }

  let k = 1024,
    dm = decimals || 2,
    sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
    i = Math.floor(Math.log(bytes) / Math.log(k))

   return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
}

export const isValidUrl = (str) => {
  const pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
    '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
    '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
    '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
    '(\\#[-a-z\\d_]*)?$','i') // fragment locator

  return !!pattern.test(str)
}

export const isValidEmail = (email) =>
  /^([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x22([^\x0d\x22\x5c\x80-\xff]|\x5c[\x00-\x7f])*\x22))*\x40([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d)(\x2e([^\x00-\x20\x22\x28\x29\x2c\x2e\x3a-\x3c\x3e\x40\x5b-\x5d\x7f-\xff]+|\x5b([^\x0d\x5b-\x5d\x80-\xff]|\x5c[\x00-\x7f])*\x5d))*$/.test(email)

export const clientId = () => {
  let firstPart = (Math.random() * 46656) | 0
  let secondPart = (Math.random() * 46656) | 0
  firstPart = ("000" + firstPart.toString(36)).slice(-3)
  secondPart = ("000" + secondPart.toString(36)).slice(-3)
  return `#${firstPart}${secondPart}`
}

export const toColor = (string, prefix = 'bg') => {


	var colors = prefix == 'bg'
  ? ['bg-red-500', 'bg-yellow-500', 'bg-green-500', 'bg-blue-500', 'bg-indigo-500', 'bg-purple-500', 'bg-pink-500']
  : ['text-red-500', 'text-yellow-500', 'text-green-500', 'text-blue-500', 'text-indigo-500', 'text-purple-500', 'text-pink-500']
	
  var hash = 0

	if (!string || string.length === 0) {
    return colors[hash]
  }

  for (var i = 0; i < string.length; i++) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash)
    hash = hash & hash
  }

  hash = ((hash % colors.length) + colors.length) % colors.length

  return colors[hash]
}

export const getInitials = (name) => {
  let initials = ''

  const parts = name.split(' ')

  if (parts.length == 1) {
    return parts[0][0]
  }

  return parts[0][0] + parts[parts.length - 1][0]
}
